/**
 * GA4 via gtag.js. Set REACT_APP_GA_MEASUREMENT_ID (e.g. G-XXXXXXXXXX) at build time.
 * Works the same on Firebase default domains and custom domains (e.g. perrisfreshmeet.com).
 */

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let ready = false;
let pendingPath = null;
let lastSentPath = null;

function sendConfigForPath(path) {
  if (!path || !window.gtag || path === lastSentPath) return;
  lastSentPath = path;
  window.gtag('config', MEASUREMENT_ID, {
    page_path: path,
    page_location: `${window.location.origin}${path}`,
  });
}

export function initGoogleAnalytics() {
  if (!MEASUREMENT_ID || typeof window === 'undefined') return;
  if (window.__fmGaInit) return;
  window.__fmGaInit = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
  script.onload = () => {
    window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
    ready = true;
    const path =
      pendingPath != null
        ? pendingPath
        : `${window.location.pathname}${window.location.search}`;
    pendingPath = null;
    sendConfigForPath(path);
  };
  document.head.appendChild(script);
}

/** Call on every client-side route change (pathname + search). */
export function gaPageView(path) {
  if (!MEASUREMENT_ID || typeof window === 'undefined' || !window.gtag) return;
  pendingPath = path;
  if (ready) {
    sendConfigForPath(path);
    pendingPath = null;
  }
}
